<template>
  <div class="toolTip-box">
    <div class="conttent">
      <p>{{text}}<br/><i v-if="sub === 'true'"></i></p>
      <p>{{text2}}<br/><i v-if="sub === 'true'"></i></p>
      <div class="btn-box">
        <button class="f-l btn cancel" v-show="qxtxt === '1'" @click = "cancelHandle()">{{leftName}}</button>
        <button class="f-r btn sure" v-show="qxtxt === '1'" @click = "sureHandle()">{{rightName}}</button>
        <button class="qx" v-show="qxtxt === '2'" @click="cancelHandle()">取消</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '升级成功'
    },
    text2: {
      type: String,
      default: '当前日历版本：XXXXX'
    },
    rightName: {
      type: String,
      default: '继续配置Wi-Fi'
    },
    leftName: {
      type: String,
      default: '取消'
    },
    sub: {
      type: String,
      default: 'false'
    },
    qxtxt: {
      type: String,
      default: '1'
    },
    name: 'UpgradeTips'
  },
  methods: {
    cancelHandle () {
      this.$emit('cancel')
    },
    sureHandle () {
      this.$router.push({path: '/hotSetting'})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.toolTip-box
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  z-index 99999999
  background rgba(0,0,0,.5)
  text-align center
  rowCloCenter()
  .conttent
    background #ffffff
    width 343px
    border-radius 10px
    colmCenter()
    p
      line-height 21px
      font-size 15px
      color #333333
      text-align center
      /*border-bottom 1px solid #ededed*/
      padding 12px 36px
      i
       font-size 12px
       color #bbbbbb
    .btn-box
      .btn
        width 50%
        height 57px
        color #333333
        background #ffffff
        font-size 16px
        box-sizing border-box
      .cancel
        border-bottom-left-radius 10px
        border-right 1px solid #ededed
      .sure
        border-bottom-right-radius 10px
        color #334f5f
</style>



// WEBPACK FOOTER //
// src/components/UpgradeTips/UpgradeTips.vue